<script setup>
import { computed, ref, nextTick, useId } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

// Único caminho de volta para um filtro de contatos salvo: sem esta lista o
// segmento só reabria pela URL ou pelo histórico do navegador.
const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const segments = useMapGetter('customViews/getContactCustomViews');

const segmentItems = computed(() =>
  (segments.value || []).map(segment => ({
    label: segment.name,
    action: 'open',
    value: segment.id,
    icon: 'i-ph-bookmark-simple',
    isSelected: Number(route.params.segmentId) === Number(segment.id),
  }))
);

const showSegments = ref(false);
const root = ref(null);
const menuId = useId();
const closeSegments = () => {
  showSegments.value = false;
  root.value?.querySelector('button')?.focus();
};
const toggleSegments = async () => {
  showSegments.value = !showSegments.value;
  if (showSegments.value) {
    await nextTick();
    document.getElementById(menuId)?.querySelector('button')?.focus();
  }
};

const openSegment = ({ value }) => {
  if (!segmentItems.value.some(item => item.value === value)) return;
  closeSegments();
  router.push({
    name: 'contacts_dashboard_segments_index',
    params: { accountId: route.params.accountId, segmentId: value },
    query: { ...route.query, page: 1 },
  });
};
</script>

<template>
  <div
    ref="root"
    v-on-clickaway="() => (showSegments = false)"
    class="relative"
    @keydown.esc.stop.prevent="closeSegments"
  >
    <Button
      v-tooltip.bottom="t('CONTACTS_LAYOUT.HEADER.ACTIONS.SAVED_FILTERS.LABEL')"
      icon="i-ph-bookmarks-simple"
      :aria-label="t('CONTACTS_LAYOUT.HEADER.ACTIONS.SAVED_FILTERS.LABEL')"
      :aria-expanded="showSegments"
      :aria-controls="showSegments ? menuId : undefined"
      class="!h-11 !w-11 !rounded-xl"
      color="slate"
      variant="ghost"
      size="sm"
      :class="showSegments ? 'bg-n-alpha-2' : ''"
      data-testid="contact-saved-filters"
      @click="toggleSegments"
    />
    <DropdownMenu
      v-if="showSegments"
      :id="menuId"
      :menu-items="segmentItems"
      empty-state-message="CONTACTS_LAYOUT.HEADER.ACTIONS.SAVED_FILTERS.EMPTY"
      class="ltr:right-0 rtl:left-0 mt-1 w-64 max-h-80 top-full"
      @action="openSegment($event)"
    />
  </div>
</template>
